/**
 * Przelotka dla wstecznej kompatybilności
 */
angular.module('ihestiaCommonDirectives.errorHandler')
  .service('ihestiaCommonErrorHandler', ['lsnCommonErrorHandler', 
    function(lsnCommonErrorHandler){
      return lsnCommonErrorHandler;
    }
  ]);
